import type { CoursesCreateNoteDto, CoursesUpdateNoteDto } from '@sportspredict/shared';
import type { Wire } from '../../types/common.types';
import { coursesApi } from './courses-base.api';
import type {
	ListNotesOutput,
	CreateNoteInput,
	CreateNoteOutput,
	UpdateNoteInput,
	UpdateNoteOutput,
	DeleteNoteInput,
	DeleteNoteOutput,
} from '../../types/notes.types';

const TAG = 'courses:notes' as const;
const INVALIDATES = [TAG] as const;

export const notesEndpoints = coursesApi.injectEndpoints({
	endpoints: (builder) => ({
		listNotes: builder.query<ListNotesOutput, void>({
			query: () => ({ url: 'courses/notes' }),
			providesTags: [TAG],
		}),
		createNote: builder.mutation<CreateNoteOutput, CreateNoteInput>({
			query: (body) => ({
				url: 'courses/notes',
				method: 'POST',
				body: body satisfies Wire<CoursesCreateNoteDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
		updateNote: builder.mutation<UpdateNoteOutput, UpdateNoteInput>({
			query: ({ id, ...body }) => ({
				url: `courses/notes/${encodeURIComponent(id)}`,
				method: 'PATCH',
				body: body satisfies Wire<CoursesUpdateNoteDto>,
			}),
			invalidatesTags: [...INVALIDATES],
		}),
		deleteNote: builder.mutation<DeleteNoteOutput, DeleteNoteInput>({
			query: ({ id }) => ({ url: `courses/notes/${encodeURIComponent(id)}`, method: 'DELETE' }),
			invalidatesTags: [...INVALIDATES],
		}),
	}),
});

export const {
	useListNotesQuery,
	useLazyListNotesQuery,
	useCreateNoteMutation,
	useUpdateNoteMutation,
	useDeleteNoteMutation,
} = notesEndpoints;
